import React from 'react';
import { Chip } from '@material-ui/core';
import moment from 'moment';

export const getColumns = (classes: any) => {
  return {
    NON_FT: {
      PROVIDER: {
        ENABLED: [
          // {
          //   title: '',
          //   field: 'priority',
          //   width: '2%',
          //   sorting: false,
          //   cellStyle: { padding: 8, zIndex: 1 },
          //   headerStyle: {
          //     padding: 0
          //   },
          //   render: (rowData: any) => {
          //     if (rowData.status === 'ENABLED')
          //       return (
          //         <Chip
          //           size="small"
          //           label="E"
          //           style={{ backgroundColor: '#0BABDE', color: '#FFFFFF', fontWeight: 500, fontSize: '14px' }}
          //         />
          //       );
          //     else
          //       return (
          //         <Chip
          //           size="small"
          //           label="D"
          //           style={{ backgroundColor: '#AD4AD0', color: '#FFFFFF', fontWeight: 500, fontSize: '14px' }}
          //         />
          //       );
          //   }
          // },
          {
            title: 'Customers',
            field: 'customerCode',
            headerStyle: { zIndex: 11 },
            width: '20%'
          },
          {
            title: 'Providers',
            field: 'providerCode',
            headerStyle: { zIndex: 11 },
            width: '20%'
          },
          {
            title: 'Provider Customer Code',
            field: 'providerCustomerCode',
            headerStyle: { zIndex: 11 },
            width: '20%'
          },
          {
            title: 'Aggregator Code',
            field: 'aggregatorCode',
            headerStyle: { zIndex: 11 },
            width: '20%'
          },
          {
            title: 'Created Date',
            field: 'createdDate',
            headerStyle: { zIndex: 11 },
            render: (rowData: any) => {
              return moment(rowData.createdDate).format('MM/DD/YYYY hh:mm:ss A');
            }
          },
          {
            title: 'Modified Date',
            field: 'lastUpdated',
            headerStyle: { zIndex: 11 },
            render: (rowData: any) => moment(rowData.lastUpdated).format('MM/DD/YYYY hh:mm:ss A')
          }
        ],
        NO_RELATION: [
          //   {
          //   title: '',
          //   field: 'priority',
          //   width: '2%',
          //   sorting: false,
          //   cellStyle: { padding: 8, zIndex: 1 },
          //   headerStyle: {
          //     padding: 0
          //   },
          //   render: (rowData: any) => {
          //     if (rowData.participantType === 'PROVIDER')
          //       return (
          //         <Chip
          //           size="small"
          //           label="P"
          //           style={{ backgroundColor: '#AD4AD0', color: '#FFFFFF', fontWeight: 500, fontSize: '14px' }}
          //         />
          //       );
          //      else if (rowData.participantType === 'CUSTOMER')
          //       return (
          //         <Chip
          //           size="small"
          //           label="C"
          //           style={{ backgroundColor: '#0BABDE', color: '#FFFFFF', fontWeight: 500, fontSize: '14px' }}
          //         />
          //       );
          //       else if (rowData.participantType === 'AGGREGATOR')
          //       return (
          //         <Chip
          //           size="small"
          //           label="A"
          //           style={{ backgroundColor: '#FFD180', color: '#FFFFFF', fontWeight: 500, fontSize: '14px' }}
          //         />
          //       );
          //       else if (rowData.participantType === 'CUSTOMER_AGGREGATOR')
          //       return (
          //         <Chip
          //           size="small"
          //           label="CA"
          //           style={{ backgroundColor: '#999999', color: '#FFFFFF', fontWeight: 500, fontSize: '14px' }}
          //         />
          //       );
          //   }
          // },
          {
            title: 'Customers',
            field: 'participantCode',
            headerStyle: { zIndex: 11 },
            width: '15%'
          },
          {
            title: 'Primary Email',
            field: 'primaryEmail',
            headerStyle: { zIndex: 11 },
            width: '25%'
          }
        ],
        REQUESTED: [
          {
            title: 'Customers',
            field: 'customerCode',
            headerStyle: { zIndex: 11 },
            width: '15%'
          },
          {
            title: 'Provider Code',
            field: 'providerCode',
            headerStyle: { zIndex: 11 },
            width: '25%'
          },
          {
            title: 'Provider Customer Code',
            field: 'providerCustomerCode',
            headerStyle: { zIndex: 11 },
            width: '20%'
          },
          {
            title: 'Aggregator Code',
            field: 'aggregatorCode',
            headerStyle: { zIndex: 11 },
            width: '20%'
          },
          {
            title: 'Created Date',
            field: 'createdDate',
            headerStyle: { zIndex: 11 },
            render: (rowData: any) => {
              return moment(rowData.createdDate).format('MM/DD/YYYY hh:mm:ss A');
            }
          },
          {
            title: 'Modified Date',
            field: 'lastUpdated',
            headerStyle: { zIndex: 11 },
            render: (rowData: any) => moment(rowData.lastUpdated).format('MM/DD/YYYY hh:mm:ss A')
          }
        ]
      },
      CUSTOMER: {
        ENABLED: [
          // {
          //   title: '',
          //   field: 'priority',
          //   width: '2%',
          //   sorting: false,
          //   cellStyle: { padding: 8, zIndex: 1 },
          //   headerStyle: {
          //     padding: 0
          //   },
          //   render: (rowData: any) => {
          //     if (rowData.status === 'ENABLED')
          //       return (
          //         <Chip
          //           size="small"
          //           label="E"
          //           style={{ backgroundColor: '#0BABDE', color: '#FFFFFF', fontWeight: 500, fontSize: '14px' }}
          //         />
          //       );
          //     else
          //       return (
          //         <Chip
          //           size="small"
          //           label="D"
          //           style={{ backgroundColor: '#AD4AD0', color: '#FFFFFF', fontWeight: 500, fontSize: '14px' }}
          //         />
          //       );
          //   }
          // },
          {
            title: 'Providers',
            field: 'providerCode',
            headerStyle: { zIndex: 11 },
            width: '20%',
            render: (rowData: any) => {
              return rowData.providerCode === 'DEFAULT' ? rowData.aggregatorCode : rowData.providerCode;
            }
          },
          {
            title: 'Customers',
            field: 'customerCode',
            headerStyle: { zIndex: 11 },
            width: '20%'
          },
          {
            title: 'Provider Customer Code',
            field: 'providerCustomerCode',
            headerStyle: { zIndex: 11 },
            width: '20%'
          },
          {
            title: 'Aggregator Code',
            field: 'aggregatorCode',
            headerStyle: { zIndex: 11 },
            width: '20%'
          },
          {
            title: 'Created Date',
            field: 'createdDate',
            headerStyle: { zIndex: 11 },
            render: (rowData: any) => {
              return moment(rowData.createdDate).format('MM/DD/YYYY hh:mm:ss A');
            }
          },
          {
            title: 'Modified Date',
            field: 'lastUpdated',
            headerStyle: { zIndex: 11 },
            render: (rowData: any) => moment(rowData.lastUpdated).format('MM/DD/YYYY hh:mm:ss A')
          }
        ],
        NO_RELATION: [
          // {
          //   title: '',
          //   field: 'priority',
          //   width: '2%',
          //   sorting: false,
          //   cellStyle: { padding: 8, zIndex: 1 },
          //   headerStyle: {
          //     padding: 0
          //   },
          //   render: (rowData: any) => {
          //     if (rowData.participantType === 'PROVIDER')
          //       return (
          //         <Chip
          //           size="small"
          //           label="P"
          //           style={{ backgroundColor: '#AD4AD0', color: '#FFFFFF', fontWeight: 500, fontSize: '14px' }}
          //         />
          //       );
          //      else if (rowData.participantType === 'CUSTOMER')
          //       return (
          //         <Chip
          //           size="small"
          //           label="C"
          //           style={{ backgroundColor: '#0BABDE', color: '#FFFFFF', fontWeight: 500, fontSize: '14px' }}
          //         />
          //       );
          //       else if (rowData.participantType === 'AGGREGATOR')
          //       return (
          //         <Chip
          //           size="small"
          //           label="A"
          //           style={{ backgroundColor: '#FFD180', color: '#FFFFFF', fontWeight: 500, fontSize: '14px' }}
          //         />
          //       );
          //       else if (rowData.participantType === 'CUSTOMER_AGGREGATOR')
          //       return (
          //         <Chip
          //           size="small"
          //           label="CA"
          //           style={{ backgroundColor: '#999999', color: '#FFFFFF', fontWeight: 500, fontSize: '14px' }}
          //         />
          //       );
          //   }
          // },
          {
            title: 'Providers',
            field: 'participantCode',
            headerStyle: { zIndex: 11 },
            width: '15%'
          },
          {
            title: 'Primary Email',
            field: 'primaryEmail',
            headerStyle: { zIndex: 11 },
            width: '25%'
          },
          {
            title: 'Participant Type',
            field: 'participantType',
            headerStyle: { zIndex: 11 },
            width: '25%',
            hidden: true
          }
        ],
        REQUESTED: [
          {
            title: 'Providers',
            field: 'providerCode',
            headerStyle: { zIndex: 11 },
            width: '15%'
          },
          {
            title: 'Customers',
            field: 'customerCode',
            headerStyle: { zIndex: 11 },
            width: '20%'
          },
          {
            title: 'Provider Customer Code',
            field: 'providerCustomerCode',
            headerStyle: { zIndex: 11 },
            width: '25%'
          },
          {
            title: 'Aggregator Code',
            field: 'aggregatorCode',
            headerStyle: { zIndex: 11 },
            width: '20%'
          },
          {
            title: 'Created Date',
            field: 'createdDate',
            headerStyle: { zIndex: 11 },
            render: (rowData: any) => {
              return moment(rowData.createdDate).format('MM/DD/YYYY hh:mm:ss A');
            }
          },
          {
            title: 'Modified Date',
            field: 'lastUpdated',
            headerStyle: { zIndex: 11 },
            render: (rowData: any) => moment(rowData.lastUpdated).format('MM/DD/YYYY hh:mm:ss A')
          }
        ]
      },
      AGGREGATOR: {
        ENABLED: [
          //   {
          //     title: '',
          //     field: 'priority',
          //     width: '2%',
          //     sorting: false,
          //     cellStyle: { padding: 8, zIndex: 1 },
          //     headerStyle: {
          //       padding: 0
          //     },
          //     render: (rowData: any) => {
          //       if (rowData.status === 'ENABLED')
          //         return (
          //           <Chip
          //             size="small"
          //             label="E"
          //             style={{ backgroundColor: '#0BABDE', color: '#FFFFFF', fontWeight: 500, fontSize: '14px' }}
          //           />
          //         );
          //       else
          //         return (
          //           <Chip
          //             size="small"
          //             label="D"
          //             style={{ backgroundColor: '#AD4AD0', color: '#FFFFFF', fontWeight: 500, fontSize: '14px' }}
          //           />
          //         );
          //     }
          //   },
          {
            title: 'Providers',
            field: 'participantCode',
            headerStyle: { zIndex: 11 },
            width: '20%'
          }
        ],
        NO_RELATION: [
          {
            title: 'Customers',
            field: 'participantCode',
            headerStyle: { zIndex: 11 },
            width: '15%'
          },
          {
            title: 'Primary Email',
            field: 'primaryEmail',
            headerStyle: { zIndex: 11 },
            width: '25%'
          }
        ],
        REQUESTED: [
          {
            title: 'Customers',
            field: 'customerCode',
            headerStyle: { zIndex: 11 },
            width: '15%'
          },
          {
            title: 'Provider Code',
            field: 'providerCode',
            headerStyle: { zIndex: 11 },
            width: '25%'
          }
        ]
      },
      CUSTOMER_AGGREGATOR: {
        ENABLED: [
          {
            title: 'Customers',
            field: 'participantCode',
            headerStyle: { zIndex: 11 },
            width: '20%',
            render: (rowData: any) => {
              return rowData.participantCode;
            }
          },
          {
            title: 'Primary Email',
            field: 'primaryEmail',
            headerStyle: { zIndex: 11 },
            width: '25%'
          }
        ],
        NO_RELATION: [
          {
            title: 'Customers',
            field: 'participantCode',
            headerStyle: { zIndex: 11 },
            width: '15%'
          },
          {
            title: 'Primary Email',
            field: 'primaryEmail',
            headerStyle: { zIndex: 11 },
            width: '25%'
          }
        ],
        REQUESTED: [
          {
            title: 'Customers',
            field: 'customerCode',
            headerStyle: { zIndex: 11 },
            width: '15%'
          },
          {
            title: 'Provider Code',
            field: 'providerCode',
            headerStyle: { zIndex: 11 },
            width: '25%'
          }
        ]
      }
    },

    FT: {
      PROVIDER: {
        ENABLED: [
          // {
          //   title: '',
          //   field: 'priority',
          //   width: '2%',
          //   sorting: false,
          //   cellStyle: { padding: 8, zIndex: 1 },
          //   headerStyle: {
          //     padding: 0
          //   },
          //   render: (rowData: any) => {
          //     if (rowData.status === 'ENABLED')
          //       return (
          //         <Chip
          //           size="small"
          //           label="E"
          //           style={{ backgroundColor: '#0BABDE', color: '#FFFFFF', fontWeight: 500, fontSize: '14px' }}
          //         />
          //       );
          //     else
          //       return (
          //         <Chip
          //           size="small"
          //           label="D"
          //           style={{ backgroundColor: '#AD4AD0', color: '#FFFFFF', fontWeight: 500, fontSize: '14px' }}
          //         />
          //       );
          //   }
          // },
          {
            title: 'Customers',
            field: 'customerCode',
            headerStyle: { zIndex: 11 },
            width: '20%'
          },
          {
            title: 'Providers',
            field: 'providerCode',
            headerStyle: { zIndex: 11 },
            width: '20%'
          },
          {
            title: 'Provider Customer Code',
            field: 'providerCustomerCode',
            headerStyle: { zIndex: 11 },
            width: '20%'
          },
          {
            title: 'Created Date',
            field: 'createdDate',
            headerStyle: { zIndex: 11 },
            render: (rowData: any) => {
              return moment(rowData.createdDate).format('MM/DD/YYYY hh:mm:ss A');
            }
          },
          {
            title: 'Modified Date',
            field: 'lastUpdated',
            headerStyle: { zIndex: 11 },
            render: (rowData: any) => moment(rowData.lastUpdated).format('MM/DD/YYYY hh:mm:ss A')
          }
        ],
        NO_RELATION: [
          {
            title: '',
            field: 'priority',
            width: '2%',
            sorting: false,
            cellStyle: { padding: 8, zIndex: 1 },
            headerStyle: {
              padding: 0
            },
            render: (rowData: any) => {
              if (rowData.participantType === 'PROVIDER')
                return (
                  <Chip
                    size="small"
                    label="P"
                    style={{ backgroundColor: '#AD4AD0', color: '#FFFFFF', fontWeight: 500, fontSize: '14px' }}
                  />
                );
              else if (rowData.participantType === 'CUSTOMER')
                return (
                  <Chip
                    size="small"
                    label="C"
                    style={{ backgroundColor: '#0BABDE', color: '#FFFFFF', fontWeight: 500, fontSize: '14px' }}
                  />
                );
              else if (rowData.participantType === 'AGGREGATOR')
                return (
                  <Chip
                    size="small"
                    label="A"
                    style={{ backgroundColor: '#FFD180', color: '#FFFFFF', fontWeight: 500, fontSize: '14px' }}
                  />
                );
              else if (rowData.participantType === 'CUSTOMER_AGGREGATOR')
                return (
                  <Chip
                    size="small"
                    label="CA"
                    style={{ backgroundColor: '#999999', color: '#FFFFFF', fontWeight: 500, fontSize: '14px' }}
                  />
                );
            }
          },
          {
            title: 'Customers',
            field: 'participantCode',
            headerStyle: { zIndex: 11 },
            width: '15%'
          },
          {
            title: 'Primary Email',
            field: 'primaryEmail',
            headerStyle: { zIndex: 11 },
            width: '25%'
          }
        ],
        REQUESTED: [
          {
            title: 'Customers',
            field: 'customerCode',
            headerStyle: { zIndex: 11 },
            width: '15%'
          },
          {
            title: 'Provider Code',
            field: 'providerCode',
            headerStyle: { zIndex: 11 },
            width: '25%'
          },
          {
            title: 'Provider Customer Code',
            field: 'providerCustomerCode',
            headerStyle: { zIndex: 11 },
            width: '20%'
          },
          {
            title: 'Created Date',
            field: 'createdDate',
            headerStyle: { zIndex: 11 },
            render: (rowData: any) => {
              return moment(rowData.createdDate).format('MM/DD/YYYY hh:mm:ss A');
            }
          },
          {
            title: 'Modified Date',
            field: 'lastUpdated',
            headerStyle: { zIndex: 11 },
            render: (rowData: any) => moment(rowData.lastUpdated).format('MM/DD/YYYY hh:mm:ss A')
          }
        ]
      },
      CUSTOMER: {
        ENABLED: [
          // {
          //   title: '',
          //   field: 'priority',
          //   width: '2%',
          //   sorting: false,
          //   cellStyle: { padding: 8, zIndex: 1 },
          //   headerStyle: {
          //     padding: 0
          //   },
          //   render: (rowData: any) => {
          //     if (rowData.status === 'ENABLED')
          //       return (
          //         <Chip
          //           size="small"
          //           label="E"
          //           style={{ backgroundColor: '#0BABDE', color: '#FFFFFF', fontWeight: 500, fontSize: '14px' }}
          //         />
          //       );
          //     else
          //       return (
          //         <Chip
          //           size="small"
          //           label="D"
          //           style={{ backgroundColor: '#AD4AD0', color: '#FFFFFF', fontWeight: 500, fontSize: '14px' }}
          //         />
          //       );
          //   }
          // },
          // {
          //   title: 'Providers',
          //   field: 'providerCode',
          //   headerStyle: { zIndex: 11 },
          //   width: '20%',
          //   render: (rowData: any) => {
          //     return rowData.providerCode === 'DEFAULT' ? rowData.aggregatorCode : rowData.providerCode;
          //   }
          // },
          {
            title: 'Customers',
            field: 'customerCode',
            headerStyle: { zIndex: 11 },
            width: '20%'
          },
          {
            title: 'Providers',
            field: 'providerCode',
            headerStyle: { zIndex: 11 },
            width: '15%'
          },
          {
            title: 'Provider Customer Code',
            field: 'providerCustomerCode',
            headerStyle: { zIndex: 11 },
            width: '20%'
          },
          {
            title: 'Aggregator Code',
            field: 'aggregatorCode',
            headerStyle: { zIndex: 11 },
            width: '20%'
          },
          {
            title: 'Created Date',
            field: 'createdDate',
            headerStyle: { zIndex: 11 },
            render: (rowData: any) => {
              return moment(rowData.createdDate).format('MM/DD/YYYY hh:mm:ss A');
            }
          },
          {
            title: 'Modified Date',
            field: 'lastUpdated',
            headerStyle: { zIndex: 11 },
            render: (rowData: any) => moment(rowData.lastUpdated).format('MM/DD/YYYY hh:mm:ss A')
          }
        ],
        NO_RELATION: [
          {
            title: '',
            field: 'priority',
            width: '2%',
            sorting: false,
            cellStyle: { padding: 8, zIndex: 1 },
            headerStyle: {
              padding: 0
            },
            render: (rowData: any) => {
              if (rowData.participantType === 'PROVIDER')
                return (
                  <Chip
                    size="small"
                    label="P"
                    style={{ backgroundColor: '#AD4AD0', color: '#FFFFFF', fontWeight: 500, fontSize: '14px' }}
                  />
                );
              else if (rowData.participantType === 'CUSTOMER')
                return (
                  <Chip
                    size="small"
                    label="C"
                    style={{ backgroundColor: '#0BABDE', color: '#FFFFFF', fontWeight: 500, fontSize: '14px' }}
                  />
                );
              else if (rowData.participantType === 'AGGREGATOR')
                return (
                  <Chip
                    size="small"
                    label="A"
                    style={{ backgroundColor: '#FFD180', color: '#FFFFFF', fontWeight: 500, fontSize: '14px' }}
                  />
                );
              else if (rowData.participantType === 'CUSTOMER_AGGREGATOR')
                return (
                  <Chip
                    size="small"
                    label="CA"
                    style={{ backgroundColor: '#999999', color: '#FFFFFF', fontWeight: 500, fontSize: '14px' }}
                  />
                );
            }
          },
          {
            title: 'Providers',
            field: 'participantCode',
            headerStyle: { zIndex: 11 },
            width: '15%'
          },
          {
            title: 'Primary Email',
            field: 'primaryEmail',
            headerStyle: { zIndex: 11 },
            width: '25%'
          }
        ],
        REQUESTED: [
          {
            title: 'Providers',
            field: 'providerCode',
            headerStyle: { zIndex: 11 },
            width: '15%'
          },
          {
            title: 'Customers',
            field: 'customerCode',
            headerStyle: { zIndex: 11 },
            width: '20%'
          },
          {
            title: 'Provider Customer Code',
            field: 'providerCustomerCode',
            headerStyle: { zIndex: 11 },
            width: '25%'
          },
          {
            title: 'Aggregator Code',
            field: 'aggregatorCode',
            headerStyle: { zIndex: 11 },
            width: '20%'
          },
          {
            title: 'Created Date',
            field: 'createdDate',
            headerStyle: { zIndex: 11 },
            render: (rowData: any) => {
              return moment(rowData.createdDate).format('MM/DD/YYYY hh:mm:ss A');
            }
          },
          {
            title: 'Modified Date',
            field: 'lastUpdated',
            headerStyle: { zIndex: 11 },
            render: (rowData: any) => moment(rowData.lastUpdated).format('MM/DD/YYYY hh:mm:ss A')
          }
        ]
      },
      AGGREGATOR: {
        ENABLED: [
          //   {
          //     title: '',
          //     field: 'priority',
          //     width: '2%',
          //     sorting: false,
          //     cellStyle: { padding: 8, zIndex: 1 },
          //     headerStyle: {
          //       padding: 0
          //     },
          //     render: (rowData: any) => {
          //       if (rowData.status === 'ENABLED')
          //         return (
          //           <Chip
          //             size="small"
          //             label="E"
          //             style={{ backgroundColor: '#0BABDE', color: '#FFFFFF', fontWeight: 500, fontSize: '14px' }}
          //           />
          //         );
          //       else
          //         return (
          //           <Chip
          //             size="small"
          //             label="D"
          //             style={{ backgroundColor: '#AD4AD0', color: '#FFFFFF', fontWeight: 500, fontSize: '14px' }}
          //           />
          //         );
          //     }
          //   },
          {
            title: 'Providers',
            field: 'participantCode',
            headerStyle: { zIndex: 11 },
            width: '20%'
          }
        ],
        NO_RELATION: [
          {
            title: 'Customers',
            field: 'participantCode',
            headerStyle: { zIndex: 11 },
            width: '15%'
          },
          {
            title: 'Primary Email',
            field: 'primaryEmail',
            headerStyle: { zIndex: 11 },
            width: '25%'
          }
        ],
        REQUESTED: [
          {
            title: 'Customers',
            field: 'customerCode',
            headerStyle: { zIndex: 11 },
            width: '15%'
          },
          {
            title: 'Provider Code',
            field: 'providerCode',
            headerStyle: { zIndex: 11 },
            width: '25%'
          }
        ]
      },
      CUSTOMER_AGGREGATOR: {
        ENABLED: [
          {
            title: 'Customers',
            field: 'participantCode',
            headerStyle: { zIndex: 11 },
            width: '20%',
            render: (rowData: any) => {
              return rowData.participantCode;
            }
          },
          {
            title: 'Primary Email',
            field: 'primaryEmail',
            headerStyle: { zIndex: 11 },
            width: '25%'
          }
        ],
        NO_RELATION: [
          {
            title: 'Customers',
            field: 'participantCode',
            headerStyle: { zIndex: 11 },
            width: '15%'
          },
          {
            title: 'Primary Email',
            field: 'primaryEmail',
            headerStyle: { zIndex: 11 },
            width: '25%'
          }
        ],
        REQUESTED: [
          {
            title: 'Customers',
            field: 'customerCode',
            headerStyle: { zIndex: 11 },
            width: '15%'
          },
          {
            title: 'Provider Code',
            field: 'providerCode',
            headerStyle: { zIndex: 11 },
            width: '25%'
          }
        ]
      }
    }
  };
};

export default getColumns;
